"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformStream = exports.StreamSlicer = exports.DecryptStreamController = void 0;
const nodeCrypto = __importStar(require("crypto"));
const crypto = (typeof window === 'undefined' ? nodeCrypto.webcrypto : window.crypto);
const ponyfill_1 = require("web-streams-polyfill/ponyfill");
const functions_1 = require("./functions");
class DecryptStreamController {
    constructor(key, iv, index, id) {
        this.key = key;
        this.iv = iv;
        this.index = index || 0;
        if (id) {
            this.file = files.get(id);
        }
    }
    transform(chunk, controller) {
        return __awaiter(this, void 0, void 0, function* () {
            let ivBytes;
            let ciphertextBytes;
            if (this.iv) {
                ivBytes = toByteArray(this.iv[this.index]);
                ciphertextBytes = chunk;
            }
            else {
                ivBytes = chunk.slice(0, functions_1.IV_LENGTH_IN_BYTES);
                ciphertextBytes = chunk.slice(functions_1.IV_LENGTH_IN_BYTES);
            }
            try {
                const cleartext = yield getCleartext(this.key, ivBytes, ciphertextBytes);
                controller.enqueue(new Uint8Array(cleartext));
                if (this.file) {
                    this.file.progress += cleartext.byteLength;
                    files.set(this.file.id, this.file);
                }
                this.index += 1;
            }
            catch (e) {
                console.log(e);
            }
        });
    }
}
exports.DecryptStreamController = DecryptStreamController;
class StreamSlicer {
    constructor(rs, mode) {
        this.mode = mode;
        this.rs = rs;
        this.chunkSize = rs;
        this.partialChunk = new Uint8Array(this.chunkSize);
        this.offset = 0;
    }
    send(buf, controller) {
        controller.enqueue(buf);
        if (this.chunkSize === 21 && this.mode === MODE_DECRYPT) {
            this.chunkSize = this.rs;
        }
        this.partialChunk = new Uint8Array(this.chunkSize);
        this.offset = 0;
    }
    //reslice input into record sized chunks
    transform(chunk, controller) {
        let i = 0;
        if (this.offset > 0) {
            const len = Math.min(chunk.byteLength, this.chunkSize - this.offset);
            this.partialChunk.set(chunk.slice(0, len), this.offset);
            this.offset += len;
            i += len;
            if (this.offset === this.chunkSize) {
                this.send(this.partialChunk, controller);
            }
        }
        while (i < chunk.byteLength) {
            const remainingBytes = chunk.byteLength - i;
            if (remainingBytes >= this.chunkSize) {
                const record = chunk.slice(i, i + this.chunkSize);
                i += this.chunkSize;
                this.send(record, controller);
            }
            else {
                const end = chunk.slice(i, i + remainingBytes);
                i += end.byteLength;
                this.partialChunk.set(end);
                this.offset = end.byteLength;
            }
        }
    }
    flush(controller) {
        if (this.offset > 0) {
            controller.enqueue(this.partialChunk.slice(0, this.offset));
        }
    }
}
exports.StreamSlicer = StreamSlicer;
function transformStream(readable, transformer, oncancel) {
    try {
        return readable.pipeThrough(new ponyfill_1.TransformStream(transformer));
    }
    catch (e) {
        const reader = readable.getReader ? readable.getReader() : readable;
        return new ponyfill_1.ReadableStream({
            start(controller) {
                if (transformer.start) {
                    return transformer.start(controller);
                }
            },
            pull(controller) {
                return __awaiter(this, void 0, void 0, function* () {
                    let enqueued = false;
                    const wrappedController = {
                        enqueue(d) {
                            enqueued = true;
                            controller.enqueue(d);
                        }
                    };
                    while (!enqueued) {
                        const data = yield reader.read();
                        if (data.done) {
                            if (transformer.flush) {
                                yield transformer.flush(controller);
                            }
                            return controller.close();
                        }
                        yield transformer.transform(data.value, wrappedController);
                    }
                });
            },
            cancel(reason) {
                readable.cancel(reason);
                if (oncancel) {
                    oncancel(reason);
                }
            }
        });
    }
}
exports.transformStream = transformStream;
function getCleartext(key, ivBytes, bytes) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield crypto.subtle.decrypt({
                name: 'AES-GCM',
                iv: ivBytes
            }, key, bytes);
        }
        catch (e) {
            console.log(e);
        }
    });
}
function toByteArray(b64) {
    return Uint8Array.from(atob(b64), c => c.charCodeAt(0));
}
//# sourceMappingURL=stream.js.map